export default __webpack_public_path__ + "static/media/partners-logo-sogang-w.49008980.webp";